/*
 * @Description: 
 * @Date: 2020-10-12 14:10:20
 * @LastEditors: wjx
 */
import { getStorage, setStorage } from "@/utils/storage.js";
// locationStorage key 'searchWords'

const search = {
  state: {
    type: 1, // 1为主页资讯搜索 2 为病例搜索
    keyword: "", // 搜索内容
    historyList: getStorage("searchWords") || [],
  },
  actions: {
    searchWordActions({ commit, state }, word) {
      commit("SET_KEYWORD", word);
      if (!word) return;

      let list = getStorage("searchWords") || [];
      list.unshift(word);
      list = Array.from(new Set(list));
      list.splice(10);
      commit("SET_HISTORYLIST", list);
      setStorage("searchWords", list);
    },
    searchClearn({ commit }) {
      setStorage("searchWords", "");
      commit("CLEARNHISTORY");
    },
  },
  mutations: {
    SET_KEYWORD(state, word) {
      state.keyword = word;
    },
    SET_HISTORYLIST(state, list) {
      state.historyList = list;
    },
    CLEARNHISTORY(state) {
      state.historyList = [];
    },
  },
};
export default search;
